import { Component, Inject, Optional } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: "offer-product-procurement-detail-dialog",
  host: { 'class': 'dialog' },
  templateUrl: './offer-product-procurement-detail.dialog.html',
  styleUrls: ['./offer-product-procurement-detail.dialog.scss']
})
export class OfferProductProcurementDetailDialogComponent {

  public form: FormGroup;
  public readonly = false;

  public product: any;

  constructor(
    public dialogRef: MatDialogRef<OfferProductProcurementDetailDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.readonly = data.readonly;
    this.product = data.product;

    this.form = new FormGroup({
      fullfillmentTime: new FormControl(data.product.procurementDetails?.fullfillmentTime),
      conditions: new FormControl(data.product.procurementDetails?.conditions),
      note: new FormControl(data.product.procurementDetails?.note),
    });
  }

  public onNoClick(): void {
    this.dialogRef.close();
  }

  public save(): void {
    this.closeDialog(this.form.value);
  }

  public closeDialog(data?: any): void {
    this.dialogRef.close(data);
  }
}
